<template>
    <b-modal id="transfer_delete" ref="transfer_delete" header-class="no-border" footer-class="no-border"
             @hidden="$emit('close')"
             :title="'Delete ' + this.transfer.data.attributes.item + '?'">
        You can't revert back your action if you delete this data. For further query, contact Database Manager!

        <template slot="modal-footer">
            <b-button size="sm" variant="secondary" @click="hideModal('transfer_delete')" v-text="'Cancel'"/>

            <state-button size="sm" variant="danger" :click="deleteTransfer">Delete</state-button>
        </template>
    </b-modal>
</template>

<script>
import StateButton from "../../../../../components/Common/StateButton";

export default {
    name: "TransferDeleteModal",

    components: {
        StateButton
    },

    props: [
        'transfer'
    ],

    methods: {
        hideModal(refname) {
            this.$refs[refname].hide();
        },

        deleteTransfer() {
            return new Promise((success, fail) => {
                this.$store.dispatch('deleteTransfer', this.order)
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('deleted-transfer');

                            this.$notify('error filled', 'Success!', 'Deleted the transfer!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('transfer_delete');
                        }, 2000);
                    })
                    .catch(error => {
                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            })
        },
    }
}
</script>

<style scoped>

</style>
